import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  useEffect(() => {
    if (!localStorage.getItem("gn_token")) return setUser(false);
    refresh();
  }, []);
  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("gn_token", r.data.token);
    setUser(r.data.user);
  };
  const setToken = async (token) => {
    localStorage.setItem("gn_token", token);
    await refresh();
  };
  const logout = () => {
    localStorage.removeItem("gn_token");
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, login, logout, refresh, setToken }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
